const buildDateRange = (date: Date, daysToGenerate: number, format: number): Date => {
  return new Date(date.getTime() + daysToGenerate * format)
}

const buildFormattedRangeDate = (from: Date, to: Date, locale: string): string => {
  const formattedFrom = new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    weekday: 'short',
    month: 'short',
  }).format(from)

  const formattedTo = new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    weekday: 'short',
    month: 'short',
    year: 'numeric',
  }).format(to)

  return `${formattedFrom} - ${formattedTo}`
}

export { buildDateRange, buildFormattedRangeDate }
